import React from 'react'

import styles from './Blog.module.css'

const Blog = ({ children }) => (
  <div className={styles.root}>
    <div className={styles.section}>
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <h2 className={styles.title}>Блог «Медузы»</h2>
          <div className={styles.subtitle}>Как мы это делаем</div>
        </header>
      </div>
    </div>
    {children}
  </div>
)

export default Blog
